export default __webpack_public_path__ + "static/media/480_private01-jp-mobile.a5e28cb3.png";